import LinkedInIcon from '@material-ui/icons/LinkedIn'
import GitHubIcon from '@material-ui/icons/GitHub'
import MailIcon from '@material-ui/icons/Mail'
import { about } from '../../portfolio'
import './About.css'

const About = () => {
  const { name, role, description, resume, social } = about

  return (
    <div className='about center'>
      {name && (
        <h1>
          Hi, I am <span className='about__name'>{name},</span>
        </h1>
      )}

      {role && <h2 className='about__role'>a {role}.</h2>}
      <p className='about__desc'>
        {/* {description && description} */}
      </p>
      <p className='about__desc'>
        I’m <span className="big"><u>passionate</u></span> about building responsive, <span className="big"><u>user-friendly websites</u></span> that look great and perform even better.
      </p>
      <p className='about__desc'>
        Whether it’s crafting custom themes or collaborating on bigger projects, I focus on creating solutions that <span className="big"><u>fit</u></span> client needs <span className="big"><u>perfectly</u>.</span>
      </p>
      <p className='about__desc'>
        I’ve worked on a mix of corporate and freelance projects, always aiming to deliver websites that are <span className="big"><u>easy to manage</u></span> and a <span className="big"><u>joy to use</u>.</span>
      </p>
      <div className='about__contact center'>
        {resume && (
          <a href={resume} target="_blank" rel="noreferrer">
            <span type='button' className='btn btn--outline'>
              Resume
            </span>
          </a>
        )}

        {social && (
          <>
            {social.linkedin && (
              <a
                href={social.linkedin}
                aria-label='linkedin'
                target="_blank"
                rel="noopener noreferrer"
                className='link link--icon'
              >
                <LinkedInIcon />
              </a>
            )}

            {social.github && (
              <a
                href={social.github}
                aria-label='github'
                className='link link--icon'
              >
                <GitHubIcon />
              </a>
            )}

            {social.mail && (
              <a
                href={`mailto:${social.mail}`}
                aria-label='email'
                target="_blank"
                rel="noopener noreferrer"
                className='link link--icon'
              >
                <MailIcon />
              </a>
            )}

            {social.upwork && (
              <a
                href={social.upwork}
                aria-label='upwork'
                target="_blank"
                rel="noopener noreferrer"
                className='link link--icon upwork'
              >
                upwork
              </a>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default About
